import { BaseEntity, DateRange } from 'yt-ng-framework';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class DeoZaResenjeZaGo 
extends BaseEntity {
constructor() {
      super();
  }
  
  ResenjeZaGoID: number = null;
  PlanZaGoID: number = null;
  OdDatuma: NgbDate = null;
  DoDatuma: NgbDate = null;
  Period: DateRange=new DateRange();
  Dana: number = null;
  RbrDela: number = null;
  DatumPocetkaRada: NgbDate = null;


  Deserialize(input: any) {
    this.ID = input.ID;
    this.ResenjeZaGoID = input.ResenjeZaGoID;
    this.PlanZaGoID = input.PlanZaGoID;
    this.OdDatuma = input.OdDatuma;
    this.DoDatuma = input.DoDatuma;
    this.Period.FromDate=input.OdDatuma;
    this.Period.ToDate=input.DoDatuma;
    this.Dana = input.Dana;
    this.RbrDela = input.RbrDela;
    this.DatumPocetkaRada = input.DatumPocetkaRada;
    return this;
  }

  Serialize(input: DeoZaResenjeZaGo) {
    input.OdDatuma=input.Period.FromDate;
    input.DoDatuma=input.Period.ToDate;
    return input;
  }
}
